/**
 * How an OAuth provider key is named in a toast.
 *
 * The keys are lower-case ("github"). Two toasts name a provider and they have
 * always differed: the sign-in RETURN toast capitalises the first letter
 * ("Google connected"), the sign-in START error toast prints the raw key
 * ("Could not start google sign-in"). Capitalising the first letter spells
 * GitHub "Github", which reads as a typo.
 *
 * Only GitHub is special-cased in both. Every other provider keeps the wording
 * it has today, "Linkedin" and the raw lower-case key included, because
 * changing it changes a live screen.
 */
const SPELLING_OVERRIDES: Record<string, string> = {
  github: "GitHub",
};

/** The return toast's wording: first letter capitalised. */
export function oauthProviderLabel(provider: string): string {
  return SPELLING_OVERRIDES[provider.toLowerCase()] ?? provider.charAt(0).toUpperCase() + provider.slice(1);
}

/** The start-error toast's wording: the raw key, except where it would misspell the name. */
export function oauthProviderKeyName(provider: string): string {
  return SPELLING_OVERRIDES[provider.toLowerCase()] ?? provider;
}
